import React, { Component } from 'react';
import Axios from 'axios';
import Cookies from 'universal-cookie';
import 'react-notifications-component/dist/theme.css';
import { store } from 'react-notifications-component';
import Button from '@material-ui/core/Button';
import swal from 'sweetalert';



const cookies = new Cookies();

class ButtonActualizar extends Component {
    constructor(props) {
        super(props);

        this.state={
            habilitado:true,           
            mes:this.props.combo1,
            año:this.props.comboId2
        }

     
           
    }
    
          Alerta=()=>{
            
              swal({
                    title:'Actualizar',
                   text: `
                   Esta seguro que desea Actualizar los siguientes datos?   
                   
                   Mes = ${this.props.combo1}
                   Año = ${this.props.comboId2}`,
                   icon:'warning',
                   buttons:['No','Si']
                })
                  .then(respuesta=>{
                       if(respuesta){
                           
                        fetch(`${process.env.REACT_APP_LOG}`, {
                            credentials:'omit',
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                           
                                Usuario: cookies.get('Usuario'),
                                Compania: cookies.get('Compania'),               
                                Actividad: ` Actualizó los siguientes datos...   
                                Mes = ${this.props.combo1}
                                Año = ${this.props.comboId2}`
                                
                            }),
                            dataType: "jsonp",
                    
                            headers:{
                              'Access-Control-Allow-Origin':'*','Accept': 'application/json',
                              'Content-Type': 'application/json'
                            }
                           
                    
                         }) 
                           swal({
                              text: 'La Actualización de Datos fué Exitosa',
                              icon:'success'
                              
                            
                            })

                            
                            fetch(`${process.env.REACT_APP_ACTUALIZAR}=${cookies.get('Servidor')}&compania=${cookies.get('Compania')}&año=${this.props.comboId2}&mes=${this.props.comboId1}`, {
                                credentials:'omit',
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })  

                            setTimeout(salir,500);

                            function salir() {
                              
                                window.location.href = "/Inicio"
                            }
                            
                        }
                       

                    })
                   
            }



   
   cancel = ()=> {
                              
    window.location.href = "/Inicio"
}

    render() {

         if(this.props.combo1 && this.props.comboId2){
             this.state.habilitado=false
         }

        return (
            <div>

                <Button onClick={() => this.Alerta()}
                    variant="contained"
                    color="primary"
                    type='submit'
                    disabled={this.state.habilitado}>
                    Actualizar 
                        </Button>&nbsp;&nbsp;

                        <Button onClick={() => this.cancel()}
                    variant="contained"
                    color="default"
                    type='submit'
                    >
                    Cancelar
                        </Button>

            </div>
        );
    }
}

export default ButtonActualizar;